<form [formGroup]="form()" (ngSubmit)="submitForm()" class="grid gap-4">
    @if (form()) {
        @for (formField of formSchema(); track formField.name) {
            @if (formField.type === 'dropdown') {
                <app-custom-dropdown
                    [options]="formField.options"
                    [label]="formField.label"
                    [placeholder]="formField.placeholder"
                    [controlName]="formField.name"
                    [formGroup]="form()"
                    [testId]="formField.testId">
                </app-custom-dropdown>
            } @else if (
                formField.type === 'text' || formField.type === 'email'
            ) {
                <app-custom-input
                    [control]="form().controls[formField.name]"
                    [type]="formField.type"
                    required="true"
                    [formControlName]="formField.name"
                    [label]="formField.label">
                </app-custom-input>
            } @else if (formField.type === 'phone') {
                <label class="pb-1 text-sm font-bold" for="phonenumber">
                    {{ formField.label }}
                </label>
                <div class="form-element mb-4 !w-full !pb-0">
                    <div class="rounded-xl border border-lightgrey">
                        <input
                            ng2TelInput
                            id="phonenumber"
                            type="text"
                            [name]="formField.name"
                            [formControlName]="formField.name"
                            placeholder="Phone number (Optional)"
                            class="rounded-xl" />
                    </div>
                    @if (
                        form().controls[formField.name].invalid &&
                        form().controls[formField.name].dirty
                    ) {
                        <p class="mt-1 text-sm font-medium text-red">
                            Phone number is invalid
                        </p>
                    }
                </div>
            } @else if (formField.type === 'textbox') {
                <textarea
                    [name]="formField.name"
                    [formControlName]="formField.name"
                    type="text"
                    [placeholder]="formField.label"
                    class="mb-4 w-full rounded-xl !border !border-lightgrey placeholder-deemphasized md:min-h-44"></textarea>
            }
        }
    }

    <app-save-button
        class="w-full"
        type="button"
        testId="checkoutAuthenticatedSaveButton"
        [additionalClasses]="['p-4 w-full md:w-3/4 mt-4 ml-0']">
        <span class="text-xl font-bold">Go</span>
    </app-save-button>
</form>
